import React from "react";
import {B2BAdvertisingProps} from "@/elements-react/b2b-advertising";

export const B2bAdvertisingDefault: React.FC<B2BAdvertisingProps> = () => {
    return(<></>);
};
